import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { ToastrService } from 'ngx-toastr';

import { Language } from '../../../../models/language';
import { Module } from '../../../../models/module';
import { Study } from '../../../../models/study';
import { StudyType } from '../../../../models/study-type';
import { AppState } from '../../../../state';
import { Category } from '../../../../models/category';
import { selectCategories } from '../../../state/category/category.selectors';
import { Subscription } from 'rxjs';
import { deleteCategory, saveCategory } from '../../../state/category/category.actions';
import { openDashboardConfirmationDialog } from '../../../state/dashboard.actions';

@Component({
  selector: 'dashboard-category-list',
  templateUrl: './category-list-dialog.component.html',
  styleUrls: ['./category-list-dialog.component.scss'],
})
export class CategoryListDialogComponent implements OnInit, OnDestroy {
  selectedStudy: Study;
  selectedModule: Module;
  selectedLanguage: Language;

  newLabel = '';

  categoryList: Category[];

  StudyType = StudyType;

  private subscriptions = new Subscription();

  constructor(
    private store: Store<AppState>,
    private toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      selectedStudy: Study;
      selectedModule: Module;
      selectedLanguage: Language;
    }
  ) {}

  ngOnInit(): void {
    this.selectedStudy = this.data?.selectedStudy;
    this.selectedModule = this.data?.selectedModule;
    this.selectedLanguage = this.data?.selectedLanguage;

    this.subscriptions.add(
      this.store.select(selectCategories).subscribe((categories) => (this.categoryList = categories))
    );
  }

  addCategory(): void {
    if (!this.newLabel) {
      return;
    }

    if (this.categoryList?.find((category) => category?.label === this.newLabel)) {
      this.toastrService.error('Category Label must be unique');
      return;
    }

    this.store.dispatch(saveCategory({ label: this.newLabel, studyId: this.selectedStudy?.id }));
    this.newLabel = '';
  }

  removeCategory(category: Category): void {
    this.store.dispatch(
      openDashboardConfirmationDialog({
        dialogData: {
          title: `Are you sure you want to delete Category ${category?.label}?`,
          onConfirm: deleteCategory({ category, studyId: this.selectedStudy?.id }),
        },
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
